import React from 'react'
import {Button, Modal, ModalHeader, ModalActions} from '../../UI/index.js'
import {formSpacing, FormStack, Input, Select} from '../../UI/forms/index.js'
import Countries from '../../../utils/Countries.js'
import type {ParcelProducts} from '../../../../types/types.js'

interface PriceRule {
    name: string
    countries?: string[]
}

interface PriceRuleModalProps {
    remove: (carrier: string, product: ParcelProducts, index: number) => void
    onChange: (carrier: string, product: ParcelProducts, index: number, priceRule: PriceRule) => void
}

interface PriceRuleModalState {
    open: boolean
    carrier?: string
    product?: ParcelProducts
    i?: number
    priceRule: PriceRule
    countries: string[]
}

class PriceRuleModal extends React.Component<PriceRuleModalProps, PriceRuleModalState> {
    initialState: PriceRuleModalState

    constructor(props: PriceRuleModalProps) {
        super(props)
        this.initialState = {
            open: false,
            priceRule: {name: ''},
            countries: []
        }
        this.state = this.initialState
    }

    open(carrier: string, product: ParcelProducts, i: number, priceRule: PriceRule, countries: string[]) {
        this.setState({open: true, carrier, product, i, priceRule, countries})
    }

    close() {
        this.setState(this.initialState)
    }

    onChangeName(event: React.ChangeEvent<HTMLInputElement>) {
        const {priceRule} = this.state
        priceRule.name = event.target.value
        this.setState({priceRule})
    }

    onChangeCountries(event: React.ChangeEvent<HTMLInputElement> & {target: {values: string[]}}) {
        const {priceRule} = this.state
        priceRule.countries = event.target.values
        this.setState({priceRule})
    }

    onRemove() {
        const {carrier, product, i} = this.state
        const {remove} = this.props
        if (carrier && product && i !== undefined) {
            remove(carrier, product, i)
        }
        this.close()
    }

    onSubmit() {
        const {carrier, product, i, priceRule} = this.state
        const {onChange} = this.props
        if (carrier && product && i !== undefined) {
            onChange(carrier, product, i, priceRule)
        }
        this.close()
    }

    render() {
        const {open, priceRule, countries} = this.state

        return (
            <Modal style={{width: 400}} show={open} onClose={this.close.bind(this)}>
                <ModalHeader title='Wijzig tariefregel' onClose={this.close.bind(this)} style={{marginBottom: 0}} />

                <FormStack style={{marginBottom: formSpacing.rowGap}}>
                    <Input
                        label='Naam'
                        value={priceRule.name}
                        onChange={this.onChangeName.bind(this)}
                    />

                    <Select
                        copy
                        label='Landen'
                        options={countries.map((countryCode) => {
                            const country = Countries.find((c) => c.code2 === countryCode) || {code2: countryCode, name: countryCode}
                            return {value: country.code2, title: country.name}
                        })}
                        values={priceRule.countries || []}
                        onChange={this.onChangeCountries.bind(this)}
                    />
                </FormStack>

                <br />
                <ModalActions>
                    <Button variant='text' onClick={this.onRemove.bind(this)}>Verwijder</Button>
                    <Button disabled={!priceRule.name || !priceRule.countries?.length} variant='text' onClick={this.onSubmit.bind(this)}>Opslaan</Button>
                </ModalActions>
            </Modal>
        )
    }
}

export default PriceRuleModal
